<main class="container-fluid px-0 pb-3 pb-lg-5">

  <div class="px-3 px-md-5 py-2 py-md-0 bg-darkest">
    <div class="container-lg">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="h3 fw-bold mb-0">{{ 'PROMOTIONS.TITLE' | translate }}</h1>
        <div class="category-icon-overlay">
          <img src="assets/icons/promotions_big.svg" alt="promotions background image" width="100%">
        </div>
      </div>
    </div>
  </div>

  <div class="px-3 px-md-5">
    <div class="container-lg">
      <div class="container-lg text-center pt-5" *ngIf="isLoading">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

<!--      user promotions -->
      <section class="pt-3 pt-lg-5" *ngIf="user && !isLoading">
        <h3 class="h4 fw-bold"> {{ 'ACCOUNT.WELCOME_MESSAGE' | translate : {username: user.fname} }}</h3>
        <h3 *ngIf="!isLoading && userPromotions.length" class="d-flex align-items-center mb-3 car-title">
          <app-svg-icon [pathIdentifier]="'mypromotions'" class="variable-svg-icon me-1"></app-svg-icon>
          <a class="h6 fw-bold mb-0 text-decoration-none" routerLink="/account/promotions">{{'PROMOTIONS.USERS.TITLE' | translate:{number: userPromotions.length} }}</a>
        </h3>

        <div class="row gy-2" *ngIf="userPromotions.length; else noPromo">
          <div class="col-12 col-sm-6 col-md-4" *ngFor="let promo of userPromotions">
            <div class="">
              <a class="bg-darker rounded-2 d-flex align-items-center justify-content-center clickable py-3" [routerLink]="'/promotions/'+promo.id">
                <img src="assets/icons/promotions_big.svg" alt="promo illustration" width="60%">
              </a>
              <h3 class="fw-bold mb-0">{{ promo.name }}</h3>
            </div>
          </div>
        </div>
      </section>

      <!--  static promotions-->
      <section class="pt-3 pt-lg-5" *ngIf="!user">
        <h3 class="d-flex align-items-center mb-3">
          <app-svg-icon [pathIdentifier]="'promotions'" class="variable-svg-icon opacity-25 me-1"></app-svg-icon>
          <span class="h6 fw-bold mb-0">{{ 'PROMOTIONS.PUBLIC.TITLE' | translate }}</span>
        </h3>

        <div class="row gy-2" *ngIf="publicPromotions.length; else noPromo">
          <div class="col-12 col-sm-6 col-md-4" *ngFor="let promo of publicPromotions">
            <div class="">
              <a class="bg-darker rounded-2 d-flex align-items-center justify-content-center clickable py-3" [routerLink]="'/promotions/'+promo.name">
                <img src="{{ promo.imgPath ?? assetsSource+'/promo.png' }}" alt="static promo illustration" width="60%">
              </a>
              <p class="mt-2 mb-0 text-secondary badge bg-lighter">{{ ('PROMOTIONS.' + promo.details.toUpperCase()) | translate }}</p>
              <h3 class="fw-bold mb-0">{{ ('PROMOTIONS.' + promo.id + '_NAME') | translate }}</h3>
              <p class="text-secondary">{{ ('PROMOTIONS.' + promo.id + '_DETAILS.0.P') | translate : {brandName} }}</p>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>

</main>

<ng-template #noPromo>
  <div class="container-lg text-center pt-5">
    <h4>{{'PROMOTIONS.NO_PROMO_MESSAGE' | translate}}</h4>
    <p class="h3">{{'PROMOTIONS.NO_PROMO_TIP' | translate}}</p>
  </div>
</ng-template>

